import styled, { css, DefaultTheme, keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { InputSizes } from "../Input/Input";

const fadeInSlideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const sizeStyles = (theme: DefaultTheme, size = InputSizes.REGULAR) =>
  ({
    small: css`
      height: ${theme.variables.height_1};
    `,
    medium: css`
      height: ${theme.variables.height_2};
    `,
    regular: css`
      height: ${theme.variables.height_3};
    `,
  })[size];

const SelectContainer = styled.div<{ $size?: InputSizes }>`
  ${({ theme, $size: size }) => sizeStyles(theme, size)}
  position: relative;
  cursor: pointer;
`;

const StyledInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  cursor: pointer;
`;

const RangeContainer = styled.div`
  position: absolute;
  width: 350px;
  border: 1px solid ${theme.colors.black};
  max-height: 200px;
  overflow-y: auto;
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.white};
  z-index: 1000;
  list-style: none;
  margin-top: 2px;
  padding: 20px 0 8px 0;
  animation: ${fadeInSlideDown} 0.1s ease-out;
  display: flex;
  flex-direction: column;

  & .confirm-container {
    padding: 0 20px 8px 0;
    align-self: flex-end;
  }
`;

const OptionItem = styled.div<{
  $selected?: boolean;
}>`
  padding: 8px;
  cursor: pointer;
  border-radius: ${theme.variables.border_radius_1};
`;

const StyledCloseContainer = styled.div<{ $visible: boolean }>`
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
`;

export {
  SelectContainer,
  StyledInputContainer,
  StyledCloseContainer,
  OptionItem,
  RangeContainer,
};
